import { css } from '@emotion/css'

export const ModalClass = css`
  .ant-drawer-content {
    .ant-drawer-body {
      padding: 15px 55px 15px 25px;

      .align-start {
        align-items: flex-start;
        .label-wrapper {
          padding-top: 4px;
        }
      }

      .field-content {
        max-width: 250px;
      }

      .footer-form {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        button {
          margin-right: 10px;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      .impairment-book-value {
        .ledger-name {
          text-align: left;
          padding-right: 5px;

          .ant-typography {
            color: inherit;
          }
        }

        .value {
          text-align: right;
        }
      }
    }
  }
`

export const AntInputAlignRight = css`
  input {
    text-align: right;
  }
`

export const SmallInputClass = css`
  &.ant-input-number {
    width: 60px !important;
  }
`

export const SmallLabelClass = css`
  font-size: 12px !important;
`
